/*
  GiftGo recently viewed.

  - On a product page, records the product handle in localStorage (most recent
    first, de-duped, capped).
  - On a page that contains the recently viewed rail, builds a card per stored
    handle from that product's JSON, reveals the rail, and hands off to
    destination.js to render the delivery promise and filter by destination.

  Vanilla JS, no dependencies. Reuses the product-rail card markup and the
  giftgo-add-to-cart element so the cards behave like every other rail.
*/
(function () {
  'use strict';

  var KEY = 'giftgo_recently_viewed';
  var MAX = 12;

  /* ------------------------------------------------------------------ store */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* ignore */
    }
  }

  function currentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function record() {
    var handle = currentProductHandle();
    if (!handle) return;
    var list = read().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    write(list.slice(0, MAX));
  }

  /* ------------------------------------------------------------- money utils */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var value = '';
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function money(cents) {
    return formatMoney(cents, window.GiftGoMoneyFormat);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* --------------------------------------------------------------- card build */
  function speedLabel(speed) {
    if (speed === '30-min') return '⚡ 30-Min Delivery';
    if (speed === 'same-day') return 'Same Day';
    if (speed === 'express') return 'Express';
    return 'Standard';
  }

  var WA_SVG =
    '<svg class="giftgo-wa-glyph" viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path fill="currentColor" d="M16.04 4C9.96 4 5 8.95 5 15.02c0 2.12.6 4.1 1.64 5.8L5 28l7.36-1.93a11 11 0 0 0 3.68.63h.01C22.12 26.7 27 21.76 27 15.69 27 9.62 22.12 4 16.04 4Zm6.43 15.5c-.27.76-1.58 1.46-2.18 1.5-.58.05-1.1.26-3.7-.77-3.13-1.23-5.1-4.4-5.26-4.6-.15-.2-1.25-1.66-1.25-3.17 0-1.5.79-2.24 1.07-2.55.27-.3.6-.38.8-.38.2 0 .4 0 .57.01.18.01.43-.07.67.51.27.66.92 2.28 1 2.45.08.16.13.35.02.56-.1.2-.16.34-.32.52-.16.18-.34.4-.48.54-.16.16-.33.33-.14.65.19.31.84 1.39 1.81 2.25 1.25 1.11 2.3 1.46 2.62 1.62.32.16.5.14.69-.08.19-.22.8-.93 1.01-1.25.21-.32.43-.27.72-.16.29.1 1.86.88 2.18 1.04.32.16.53.24.61.37.08.13.08.76-.19 1.52Z"/></svg>';

  // Nigeria-only products are ordered over WhatsApp; everything else gets the
  // Buy now button. Mirrors giftgo-card-cta.liquid.
  function secondCta(p, variant, url) {
    var isNg = (p.tags || []).indexOf('dest:ng') !== -1;
    var waNum = String(window.GiftGoWhatsApp || '').replace(/[^0-9]/g, '');
    if (isNg && waNum) {
      var msg =
        (window.GiftGoWhatsAppOrderMsg || 'Hi GiftGo, I want to order:') +
        ' ' + p.title + ' - ' + money(p.price) + ' - ' + location.origin + url;
      return (
        '<a class="giftgo-cta-btn giftgo-cta-btn--wa giftgo-card-cta__slot" target="_blank" rel="noopener" href="https://wa.me/' +
        waNum + '?text=' + encodeURIComponent(msg) + '">' + WA_SVG + '<span>WhatsApp</span></a>'
      );
    }
    return (
      '<giftgo-add-to-cart class="giftgo-card-add giftgo-card-cta__slot" data-variant-id="' + variant.id + '" data-buy-now="1">' +
      '<button type="button" class="giftgo-cta-btn giftgo-cta-btn--buy">Buy now</button>' +
      '</giftgo-add-to-cart>'
    );
  }

  function buildCard(p) {
    var tags = p.tags || [];
    var dest = tags
      .filter(function (t) {
        return t.indexOf('dest:') === 0;
      })
      .join(' ');
    var speedTag = tags.filter(function (t) {
      return t.indexOf('speed:') === 0;
    })[0];
    var speed = speedTag ? speedTag.replace('speed:', '') : 'standard';

    var variant = (p.variants || []).filter(function (v) {
      return v.available;
    })[0] || (p.variants || [])[0];

    var url = '/products/' + p.handle;
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var discount = onSale ? Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price) : 0;

    var item = document.createElement('div');
    item.className = 'giftgo-rail__item';
    item.setAttribute('data-giftgo-dest', dest);

    item.innerHTML =
      '<a href="' + url + '" class="giftgo-rail__media" tabindex="-1" aria-hidden="true">' +
      (onSale ? '<span class="giftgo-rail__discount">-' + discount + '%</span>' : '') +
      '<span class="delivery-badge delivery-badge--' + speed + ' delivery-badge--overlay" data-delivery-badge data-speed="' + speed + '">' + speedLabel(speed) + '</span>' +
      (p.featured_image ? '<img src="' + escapeHtml(sized(p.featured_image, 440)) + '" loading="lazy" alt="' + escapeHtml(p.title) + '">' : '') +
      '</a>' +
      '<div class="giftgo-rail__body">' +
      '<a href="' + url + '" class="giftgo-rail__name">' + escapeHtml(p.title) + '</a>' +
      '<div class="giftgo-rail__pricerow">' +
      '<span class="giftgo-rail__price' + (onSale ? ' giftgo-rail__price--sale' : '') + '">' + money(p.price) + '</span>' +
      (onSale ? '<s class="giftgo-rail__compare">' + money(p.compare_at_price) + '</s>' : '') +
      '</div>' +
      /* oct18j: no delivery text on cards (product page + cart keep it) */
      (variant && p.available
        ? '<div class="giftgo-card-cta">' +
          '<giftgo-add-to-cart class="giftgo-card-add giftgo-card-cta__slot" data-variant-id="' + variant.id + '">' +
          '<button type="button" class="giftgo-cta-btn giftgo-cta-btn--add">Add to cart</button>' +
          '</giftgo-add-to-cart>' +
          secondCta(p, variant, url) +
          '</div>'
        : '') +
      '</div>';

    return item;
  }

  function refreshDestination(attempt) {
    if (window.GiftGo && typeof window.GiftGo.refresh === 'function') {
      window.GiftGo.refresh();
    } else if ((attempt || 0) < 20) {
      setTimeout(function () {
        refreshDestination((attempt || 0) + 1);
      }, 100);
    }
  }

  function populate() {
    var rail = document.querySelector('[data-giftgo-rv]');
    if (!rail) return;
    var row = rail.querySelector('[data-giftgo-rv-row]');
    if (!row) return;

    var here = currentProductHandle();
    var handles = read().filter(function (h) {
      return h !== here; // never suggest the product you are already on
    });
    if (handles.length === 0) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var added = 0;
      products.forEach(function (p) {
        if (p && p.handle) {
          row.appendChild(buildCard(p));
          added += 1;
        }
      });
      if (added > 0) {
        rail.hidden = false;
        refreshDestination(0);
      }
    });
  }

  /* --------------------------------------------------------------------- init */
  function init() {
    record();
    populate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
